import script from "./InteractiveItem.vue?vue&type=script&setup=true&lang=js"
export * from "./InteractiveItem.vue?vue&type=script&setup=true&lang=js"

import "./InteractiveItem.vue?vue&type=style&index=0&id=27711ccc&lang=less&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27711ccc"]])

export default __exports__